import { render, staticRenderFns } from "./ServiceSliderSelector.vue?vue&type=template&id=9b6b06f6&scoped=true&"
import script from "./ServiceSliderSelector.vue?vue&type=script&lang=ts&"
export * from "./ServiceSliderSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6b06f6",
  null
  
)

export default component.exports